import { BaseTenantLinksDto } from '../../shared/dtos/base-tenant-links.dto';

/**
 * Vehicle road tax links DTO
 */
export class VehicleRoadTaxLinksDto extends BaseTenantLinksDto {}
